import { DirectorySearchChannelsModule } from './directory-search-channels/directory-search-channels.module';
import { DirectorySearchComponent } from './directory-search.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Kno2DirectorySearchModule } from './directory-search-kno2/directory-search-kno2.module';
import { DirectorySearchSelectionModule } from './directory-search-selection/directory-search-selection.module';

@NgModule({
  declarations: [DirectorySearchComponent],
  exports: [DirectorySearchComponent],
  imports: [
    CommonModule,
    DirectorySearchSelectionModule,
    Kno2DirectorySearchModule,
    DirectorySearchChannelsModule
  ]
})
export class DirectorySearchModule { }
